export default {
  addRole: {
    server: '/roles',
    method: 'post',
  },
  getRoles: {
    server: '/roles',
    method: 'get',
  },
  putRole: {
    server: '/roles/{roleId}',
    method: 'put',
  },
  deleteRole: {
    server: '/roles/{roleId}',
    method: 'delete',
  },
  putRolePermissions: {
    server: '/roles/{roleId}/permissions',
    method: 'put',
  },
  getRolePermissions: {
    server: '/roles/{roleId}/permissions',
    method: 'get',
  },
};
